import React, { FC } from 'react'
import { Box, Grid, Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { GridRow } from '../../../../components/GridRow'
// import { Allocations } from './Allocations'
// import { Performance } from './Performance'
// import { Summary } from './Summary'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
}))

export const Portfolio: FC = () => {
  const classes = useStyles()

  return (
    <Box className={classes.container}>
      <Grid item xs={12}>
        <Typography variant="h1">Portfolio</Typography>
      </Grid>
      <GridRow spacing={4}>
        <Grid container item xs={12} justifyContent={'center'}>
          <Typography variant="h4" paddingTop={10}>
            Coming soon..
          </Typography>
        </Grid>

        {/* <Grid item xs={6}> */}
        {/*  <Allocations title={'Allocations'} /> */}
        {/* </Grid> */}
        {/* <Grid item xs={6}> */}
        {/*  <Grid item xs={12}> */}
        {/*    <Performance title={'Performance'} /> */}
        {/*  </Grid> */}
        {/*  <Grid item xs={12}> */}
        {/*    <Summary /> */}
        {/*  </Grid> */}
        {/* </Grid> */}
      </GridRow>
    </Box>
  )
}
